import { getAxios } from '@parchment/oauth2-axios';
import { checkHttpStatus } from '../common/utils/ApiUtils';
import { CREATE_NEW_MEMBER_ERROR, CREATE_NEW_MEMBER_SUCCESS,
    CREATE_NEW_MEMBER_ADMIN_ERROR, CREATE_NEW_MEMBER_ADMIN_SUCCESS,
    MEMBER_SERVICE_API_KEY } from './index';

const MEMBER_SERVICE_BASE_URL = window.config.service.memberServiceApiUrl;

export async function addNewMember(params = {}) {
    const url = `${MEMBER_SERVICE_BASE_URL}/member`;
    try {
         const response = await getAxios(MEMBER_SERVICE_API_KEY).post(url, {member: params});
         checkHttpStatus(response);
         return {
            type: CREATE_NEW_MEMBER_SUCCESS,
            payload: response.data
         };
    } catch (error) {
        return {
            type: CREATE_NEW_MEMBER_ERROR,
            payload: error
        };
    }
}

export async function addNewMemberAdmin(params = {}) {
    const url = `${MEMBER_SERVICE_BASE_URL}/memberAdmin`;
    try {
        const response = await getAxios(MEMBER_SERVICE_API_KEY).post(url, params);
        checkHttpStatus(response);
        return {
            type: CREATE_NEW_MEMBER_ADMIN_SUCCESS,
            payload: response.data
        };
    } catch (error) {
        return {
            type: CREATE_NEW_MEMBER_ADMIN_ERROR,
            payload: error
        };
    }
}
